module.exports = __webpack_public_path__ + "h5/img/detail_bg1.a121854f.png";